// Deterministic, pleasant color per user id (for live cursors / avatars).
const PALETTE = [
  '#2f7d6b', '#c1683f', '#3b6ea5', '#9b59b6',
  '#16a085', '#d4a017', '#c0392b', '#2c82c9',
];

export function colorForId(id = '') {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
}
